import ApplicationController from "./application_controller"
import Logger from '../lib/logger'
import * as bootstrap from "bootstrap"

export default class extends ApplicationController {
  connect() {
    super.connect()
    this.modalElement = this.element.closest('.modal') || this.element

    if (!this.modalElement || !this.modalElement.classList.contains('modal')) {
      Logger.error('Modal controller: No valid modal element found')
      return
    }

    this.modal = new bootstrap.Modal(this.modalElement, {})

    // Only show if auto-show is enabled and we're not in a Turbo preview
    // This prevents the modal from re-opening when restoring from cache
    if (this.element.dataset.autoShow !== 'false' && !document.documentElement.hasAttribute("data-turbo-preview")) {
      this.modal.show()
    }

    this._handleShown = () => {
      Logger.debug('Modal shown via controller, initializing tooltips')
      setTimeout(() => {
        if (typeof window.initializeTooltips === 'function') {
          window.initializeTooltips()
        }
      }, 150)
    }

    this._handleHidden = () => {
      this.hideModal()
    }

    this._handleGlobalHide = () => {
      this.hideModal()
    }

    this._handleBeforeCache = () => {
      this.hideModal()
      if (this.element) {
        // Prevent auto-show when this page is restored from cache
        this.element.dataset.autoShow = 'false'
      }
      
      // Force cleanup of Bootstrap artifacts that might be stuck in the snapshot
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove())
      document.body.classList.remove('modal-open')
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    }

    this.modalElement.addEventListener("shown.bs.modal", this._handleShown)
    this.modalElement.addEventListener("hidden.bs.modal", this._handleHidden)
    document.addEventListener("modal:hide", this._handleGlobalHide)
    document.addEventListener("turbo:before-cache", this._handleBeforeCache)
  }

  disconnect() {
    super.disconnect()
    if (this.modalElement) {
      this.modalElement.removeEventListener("shown.bs.modal", this._handleShown)
      this.modalElement.removeEventListener("hidden.bs.modal", this._handleHidden)
    }
    document.removeEventListener("modal:hide", this._handleGlobalHide)
    document.removeEventListener("turbo:before-cache", this._handleBeforeCache)
  }

  hideModal() {
    if (this.modal) {
      this.modal.hide()
    }
  }

  // A link inside this modal that targets ANOTHER frame (data-turbo-frame). The link's own
  // fetch loads the target; this action only does what the modal itself owns — closing.
  // Bootstrap stacks modals by DOM order, not the order they were shown, so without it the
  // loaded frame would sit underneath this modal and the click would visibly do nothing.
  back() {
    this.hideModal()
  }

  submitEnd(e) {
    // Ignore GET requests (e.g. search/filter form submissions) to prevent modal from closing
    if (e.target && e.target.method && e.target.method.toLowerCase() === 'get') {
      return
    }

    // Ignore forms that are explicitly marked to be ignored
    if (e.target && (e.target.dataset.modalIgnore === 'true' || e.target.closest('[data-modal-ignore="true"]'))) {
      return
    }

    if (e.detail.success === true) {
      this.hideModal()

      // Handle history state and page refresh
      const fetchResponse = e.detail.fetchResponse
      if (fetchResponse && fetchResponse.response.redirected) {
        Logger.debug('Modal success: redirecting to', fetchResponse.response.url)
        // Use 'replace' to ensure the modal edit page is skipped in browser history
        window.Turbo.visit(fetchResponse.response.url, { action: "replace" })
      }
    }
  }
}
